import { Component, Element, Event, h, Host, Listen, Prop } from "@stencil/core";
export class CLink {
  constructor() {
    this.iconPos = 'after';
    this.version = '2.18.1';
  }
  handleFocus() {
    this.linkFocus.emit();
  }
  handleBlur() {
    this.linkBlur.emit();
  }
  handleKeyDown(ev) {
    // if enter or spacebar is pressed on this element, we delegate it to click
    if (ev.key === 'Enter' || ev.key === 'Space') {
      this.el.click();
    }
  }
  handleClick() {
    // if enter or spacebar is pressed on this element, we delegate it to click
    if (this.href) {
      if (this.target === "_blank") {
        window.open(this.href);
      }
      else {
        location.href = this.href;
      }
    }
  }
  getTabindex() {
    return this.disabled ? '-1' : this.tabbedIndex ? this.tabbedIndex : this.href ? '0' : null;
  }
  render() {
    return (h(Host, { class: "c-link", exportparts: "c-link-icon", role: "link", tabindex: this.getTabindex() },
      this.iconPos === 'before' ?
        h("span", { class: "c-link__text--after" },
          h("slot", null, this.text)) :
        h("slot", null, this.text),
      this.icon &&
        h("c-icon", { class: { 'c-link__icon': true, 'c-link__icon--before': this.iconPos === 'before' }, name: this.icon, part: "c-link-icon" })));
  }
  static get is() { return "c-link"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["c-link.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["c-link.css"]
  }; }
  static get properties() { return {
    "href": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "href",
      "reflect": true
    },
    "target": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "target",
      "reflect": true
    },
    "alert": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "alert",
      "reflect": true
    },
    "block": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "block",
      "reflect": true
    },
    "centered": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "centered",
      "reflect": true
    },
    "disabled": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "disabled",
      "reflect": true
    },
    "icon": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "icon",
      "reflect": true
    },
    "iconPos": {
      "type": "string",
      "mutable": true,
      "complexType": {
        "original": "'before' | 'after'",
        "resolved": "\"after\" | \"before\"",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "icon-pos",
      "reflect": true,
      "defaultValue": "'after'"
    },
    "primary": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "primary",
      "reflect": true
    },
    "tabbedIndex": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "tabbed-index",
      "reflect": true
    },
    "text": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "text",
      "reflect": false
    },
    "version": {
      "type": "string",
      "mutable": true,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "version",
      "reflect": true,
      "defaultValue": "'2.18.1'"
    }
  }; }
  static get events() { return [{
      "method": "linkFocus",
      "name": "linkFocus",
      "bubbles": true,
      "cancelable": true,
      "composed": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "complexType": {
        "original": "FocusEvent",
        "resolved": "FocusEvent",
        "references": {
          "FocusEvent": {
            "location": "global"
          }
        }
      }
    }, {
      "method": "linkBlur",
      "name": "linkBlur",
      "bubbles": true,
      "cancelable": true,
      "composed": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "complexType": {
        "original": "FocusEvent",
        "resolved": "FocusEvent",
        "references": {
          "FocusEvent": {
            "location": "global"
          }
        }
      }
    }]; }
  static get elementRef() { return "el"; }
  static get listeners() { return [{
      "name": "focus",
      "method": "handleFocus",
      "target": undefined,
      "capture": false,
      "passive": false
    }, {
      "name": "blur",
      "method": "handleBlur",
      "target": undefined,
      "capture": false,
      "passive": false
    }, {
      "name": "keydown",
      "method": "handleKeyDown",
      "target": undefined,
      "capture": false,
      "passive": false
    }, {
      "name": "click",
      "method": "handleClick",
      "target": undefined,
      "capture": false,
      "passive": false
    }]; }
}
